import { Route, Switch } from "react-router-dom";

import CrmHistoryCpmponent from "../../components/page/memberManage/CrmHistoryCpmponent";
import LonglifePushComponent from "../../components/page/memberManage/LonglifePushComponent";
import MemberManageComponent from "../../components/page/memberManage/MemberManageComponent";
import SmsSendComponent from "../../components/page/memberManage/SmsSendComponent";

const MemberManagePage = () => {
  return (
    <Switch>
      <Route
        exact
        path="/memberManage/view"
        component={MemberManageComponent}
      />
      <Route
        exact
        path="/memberManage/crmHistory"
        component={CrmHistoryCpmponent}
      />
      <Route exact path="/memberManage/send/sms" component={SmsSendComponent} />
      <Route
        exact
        path="/memberManage/longlife/push"
        component={LonglifePushComponent}
      />
    </Switch>
  );
};

export default MemberManagePage;
